import React, { useEffect, useState } from 'react';
import { removeAttributeType, addAttributeTypeToAllCheckedAttribute } from 'parser/filterParser';
import _ from 'lodash';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_FILTER_ATTRIBUTE_SELECTION } from 'utils/mixpanelEventNames';

interface Props {
    attributeType: any;
    setAllCheckedAttribute: Function;
    allCheckedAttribute: any;
    allAttributeNames: any;
    allSelectedValueForAllAttribute?: any;
    setAllSelectedValueForAllAttribute: any;
    setApplyFilterObject: Function;
    applyFilterObject: any;
    dimension: any;
}
function FilterSelectAllCheckBox({
    attributeType,
    setAllCheckedAttribute,
    allCheckedAttribute,
    allAttributeNames,
    allSelectedValueForAllAttribute,
    setAllSelectedValueForAllAttribute,
    setApplyFilterObject,
    applyFilterObject,
    dimension,
}: Props) {
    const [checkBox, setCheckBox] = useState(true);
    function onClickOfSelectAll(e: any) {
        let applyFilterObjectTemp = _.cloneDeep(applyFilterObject);
        applyFilterObjectTemp[dimension.dimensionReference][attributeType] = {};
        setApplyFilterObject(applyFilterObjectTemp);

        if (!e.target.checked) {
            setAllCheckedAttribute(removeAttributeType(allCheckedAttribute, attributeType));
        } else {
            addAttributeTypeToAllCheckedAttribute(setAllCheckedAttribute, attributeType, allAttributeNames);
        }
        setAllSelectedValueForAllAttribute((oldData: any) => ({ ...oldData, [attributeType]: e.target.checked }));

        //mixpanel event
        trackEventMixpanel(GLOBAL_FILTER_ATTRIBUTE_SELECTION, {
            attributeType: attributeType,
            attributeName: 'Select All',
            dimension: dimension?.dimensionReference,
            isChecked: e.target.checked,
        });
    }

    function checkSelectAll(allAttributeNames: any, allCheckedAttribute: any, setCheckBox: Function) {
        for (let attrName of allAttributeNames) {
            if (attrName?.isActive) {
                if (
                    allCheckedAttribute?.[attributeType] &&
                    !(attrName?.attributeExId in allCheckedAttribute?.[attributeType])
                ) {
                    setCheckBox(false);
                    return;
                }
            }
        }
        setCheckBox(true);
    }

    useEffect(() => {
        checkSelectAll(allAttributeNames, allCheckedAttribute, setCheckBox);
    }, [allAttributeNames, allCheckedAttribute]);

    return (
        <label className=" w-full font-xs flex items-center gap-4 cursor-pointer">
            <input
                type={'checkbox'}
                className={'checkbox-size accent-purpleFont'}
                checked={checkBox}
                onClick={(e) => onClickOfSelectAll(e)}
            />
            <span>Select All</span>
        </label>
    );
}

export default FilterSelectAllCheckBox;
